export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_04_06.62b097c2.mp4";